import Vue from 'vue'

/**
 * Suppress the warning message which is caused by vuetify
 * @link https://github.com/vuetifyjs/vuetify/issues/9999
 */
const ignoredMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'

Vue.config.warnHandler = (message, vm, componentTrace) => {
  if (message !== ignoredMessage) {
    console.error(message + componentTrace)
  }
}
